import React, { useEffect, useState } from "react";
import { Card, Button, Progress, Typography, Row, Col, List, Space } from "antd";
import { CheckCircleFilled, CheckCircleOutlined, SettingOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AUTH_TOKEN, ORG_ID, DOMAIN_ID, REACT_APP_API_TENANTS_URL } from "../../constants";

const { Title, Text } = Typography;

const SetupGuide = ({ setIsShowTour }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [tourDetails, setTourDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getTourDetails();
  }, []);

  const handleDismiss = async () => {
    console.log("api called ");

    const payload = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      setupId: 4,
      status: "",
      overallStatus: "false",
    };
    try {
      const res = await axios.post(`${REACT_APP_API_TENANTS_URL}/setTenantSetup`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });
    } catch (error) {
      console.error(error);
    }
    setIsShowTour(false);
  };

  const handleUpdateSetupStatus = async (id) => {
    const payload = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      setupId: id,
      status: "true",
      overallStatus: "",
    };
    try {
      const res = await axios.post(`${REACT_APP_API_TENANTS_URL}/setTenantSetup`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getTourDetails = async () => {
    try {
      setIsLoading(true);
      let payload = {
        orgId: ORG_ID(),
        tenantId: DOMAIN_ID(),
      };
      const res = await axios.post(`${REACT_APP_API_TENANTS_URL}/getTenantStatus`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });

      // storing the tour status in local storage
      // This is to check if the tour is already completed or not
      // In different screens, alternative is to keep calling it everywhere
      if (res?.data?.setups) {
        const tourStatus = {
          setupAD: !res?.data?.setups[0]?.steps[0]?.status,
          setupWallet: !res?.data?.setups[0]?.steps[1]?.status,
          setupADPolicy: !res?.data?.setups[0]?.steps[2]?.status,
        };

        localStorage.setItem("tourStatus", JSON.stringify(tourStatus));
      }

      setTourDetails(res?.data?.setups);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Card
        title="Setup Tour"
        style={{ marginBottom: "1rem" }}
        extra={
          <Button type="link" style={{ color: "#1677ff" }} onClick={handleDismiss}>
            Dismiss
          </Button>
        }
      >
        {/* Setup Cards */}
        <Row gutter={16}>
          {tourDetails?.map((card) => (
            <Col xs={24} sm={12} md={6} key={card.id}>
              <Card
                style={{
                  backgroundColor: "white",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Title level={5} style={{ marginTop: 0, fontSize: 14 }}>
                    {card.title}
                  </Title>
                  {card.steps?.map((step) => (
                    <Link
                      to={step?.link}
                      key={step.id}
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={() => {
                        if (step?.link.includes("help.authnull.com")) {
                          handleUpdateSetupStatus(step.id);
                        }
                      }}
                    >
                      {step.status ? (
                        <CheckCircleFilled
                          style={{
                            color: "#1a8a22",
                            marginRight: 8,
                          }}
                        />
                      ) : (
                        <CheckCircleFilled
                          style={{
                            marginRight: 8,
                            color: "#a3a2a2",
                          }}
                        />
                      )}
                      <Text
                        key={step.id}
                        style={{ fontSize: 14, display: "block", color: "#1677ff" }}
                      >
                        {step.stepTitle}
                      </Text>
                    </Link>
                  ))}
                </div>
                <Link
                  to="https://help.authnull.com/docs/active-directory/"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Button color="primary" variant="outlined" block style={styles.cardBtn}>
                    Learn More
                  </Button>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </>
  );
};

const styles = {
  cardBtn: {
    marginTop: "16px",
    width: "100%",
  },
};

export default SetupGuide;
